import { RESET_PASSWORD_PROMPT, PASSWORD_SERVER_ERROR, FORGOT_EMAIL_LOGIN } from './constant'
import { GetterTree } from 'vuex'
import { AuthState } from './types'

export const getters: GetterTree<AuthState, any> = {
  [RESET_PASSWORD_PROMPT]: state => state.resetPasswordPrompt,
  [PASSWORD_SERVER_ERROR]: state => state.passwordError,
  [FORGOT_EMAIL_LOGIN]: state => state.forgotEmailLogin
}
